import { useQuery } from '@tanstack/react-query';
import { dailyQuestionApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Daily-report questions configured for a job. */
export function useQuestions(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.questions.forJob(jobId ?? -1),
    queryFn: ({ signal }) =>
      dailyQuestionApiClient.list({ jobId: jobId! }, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    meta: { suppressErrorToast: true, errorContext: 'daily questions' },
  });
}
